<template>
    <div class="goods_list_container">
        <!-- 产品分类 start -->
            <div class="product_tree">
                <div class="product_title">
                    产品分类
                </div>
                <div class="product_tree_box">
                    <el-tree :data="product_list.data" :props="defaultProps" @node-click="goGoodList"  />
                </div>
                <div class="product_tree_foot">

                </div>
            </div>
          <div class="new_pla">
                  <!-- 产品分类 end -->
                <div class="goods_list clearfix">
                
                    <!-- 商品列表 -->
                    <ul :class="{ sld_goods_list: true, skeleton_sld_goods_list: firstLoading }">
                        <li v-for="({ goodsName, goodsImage, goodsPrice, saleNum, activityList, isFollowGoods, defaultProductId,productVOList,storageName,carriageName,qualityGuaranteePeriod,goodsCode,is_show,terminalGoodsPrice,dealerGoodsPrice }, index) in (firstLoading ? skeletonData.data : goodsData.data)"
                            :key="index">
                        
                            <div class="new_li">
                                <div class="flex_column_around_start">
                                    <div class="sld_h32_hide">
                                        <router-link class="sld_goods_name" target="_blank"
                                            :to="`/goods/detail?productId=${defaultProductId}`">
                                            <span v-html="goodsName"></span>
                                        </router-link>
                                    </div>
                                    <div class="sld_h32_hide flex_row_around_start">
                                    <div class="sld_item" v-if="goodsCode">货号：<span>{{goodsCode}}</span></div>
                                    <div class="sld_item" v-if="storageName">储存条件：<span>{{storageName}}</span></div>
                                    <div class="sld_item" v-if="carriageName">运输方式：<span>{{carriageName}}</span></div>
                                    <div class="sld_item" v-if="qualityGuaranteePeriod">保质期：<span>{{qualityGuaranteePeriod}}</span></div>
                                    </div>
                                    <div class="sld_h32_hide flex_row_around_start">
                                        <div class="sld_item--block" v-if="productVOList && productVOList.length">{{ productVOList[0].subjectName }}</div>
                                    </div>
                                </div>
                        
                                <div class="sld_img sld_img_center">
                                    <router-link target="_blank" :to="`/goods/detail?productId=${defaultProductId}`">
                                        <div class="img_go" :style="{ backgroundImage: `url(${goodsImage})` }"></div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="is_open">
                                <div class="open_top flex_row_between_start" @click="get_show(index)">
                                    <div>商品规格</div>
                                    <img src="../../assets/downarrow.png" alt="" v-if="is_show">
                                    <img src="../../assets/uparrow.png" alt="" v-else>
                                </div>
                                <div class="detail_sepc" v-if="is_show">
                                    <div class="flex_row_between_center sepc_top">
                                        <div class="sepc_item">
                                            规格
                                        </div>
                                        <div class="sepc_item">
                                            价格
                                        </div>
                                        <div class="sepc_item" v-if="terminalGoodsPrice">
                                            终端价
                                        </div>
                                        <div class="sepc_item" v-if="dealerGoodsPrice">
                                            经销商价
                                        </div>
                                        <div class="sepc_item">
                                            货期
                                        </div>
                                        <div class="sepc_item">
                                            数量
                                        </div>
                                        <div class="sepc_item">
                                            加入购物车
                                        </div>
                                    </div>
                                    <div class="flex_row_between_center sepc_bom" style="margin-top: 20rpx;" v-for="(item,index) in productVOList" :key="index" >
                                        <div class="sepc_item">
                                            {{ item.specValues }}
                                        </div>
                                        <div class="sepc_item">
                                            {{item.productPrice}}
                                        </div>
                                        <div class="sepc_item" v-if="item.terminalGoodsPrice">
                                            {{item.terminalGoodsPrice}}
                                        </div>
                                        <div class="sepc_item" v-if="item.dealerGoodsPrice">
                                            {{item.dealerGoodsPrice}}
                                        </div>
                                        <div class="sepc_item">
                                            {{item.productionTime}}
                                        </div>
                                        <div class="sepc_item">
                                            <div class="goods_edit_nem flex_row_center_center">
                                                <span @click="editNum('reduce', item)">-</span>
                                                <input type="number" v-model="item.buyNum" @input="editNum('edit', item, $event)"
                                                    @blur="editNum('blur', item, $event)" />
                                                <span @click="editNum('add', item)">+</span>
                                            </div>
                                        </div>
                                        <div class="sepc_item" @click="addCart(item)">
                                        <img src="@/assets/shopping_cart.png" alt="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <SldCommonEmpty v-show="isEmpty" />
                </div>

                <!-- 分页 -->
                <div class="flex_row_center_center sld_pagination">
                    <el-pagination @current-change="handleCurrentChange" v-model:currentPage="goodsData.page.current"
                        :page-size="goodsData.page.pageSize" layout="prev, pager, next, jumper" :total="goodsData.page.total"
                        :hide-on-single-page="true">
                    </el-pagination>
                </div>
          </div>

        <SldLoginModal :visibleFlag="loginModalVisibleFlag" @closeLoingModal="closeLoingModal" />
    </div>

</template>
<script>
import { getCurrentInstance, onMounted, reactive, ref, watchEffect, watch } from 'vue';
import { ElMessage } from 'element-plus'
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import GoodsListCate2 from '@/components/GoodsListCate2';
import GoodsListCate3 from '@/components/GoodsListCate3';
import SldLoginModal from "../../components/loginModal";
import SldCommonEmpty from '../../components/SldCommonEmpty'

export default {
    name: 'goodsList',
    components: {
        GoodsListCate2,
        GoodsListCate3,
        SldLoginModal,
        SldCommonEmpty
    },
    setup() {
        //变量------------------------------
        const firstLoading = ref(true);//是否第一次加载
        const skeletonData = reactive({ data: [] });
        const store = useStore();
        const product_list = reactive({
			data:[]
		})
        const loginModalVisibleFlag = ref(false);//登录弹框是否显示，默认不显示
        const initSkeletonData = () => {
            for (let i = 0; i < 10; i++) {
                skeletonData.data.push({
                    goodsName: '',
                    goodsImage: '',
                    goodsPrice: '',
                    saleNum: '',
                    activityList: '',
                    isFollowGoods: '',
                    defaultProductId: '',
                });
            }
        }
        initSkeletonData();
        const route = useRoute()
        const router = useRouter()
        const catePath = ref([]) //导航路径
        const showIndex = ref(0) //显示flag
        const catePathName = reactive({ path: [] }) //需要在页面显示的整个分类路径
        const params = reactive({ //初始化的请求参数
            current: 1,
        })
        const { proxy } = getCurrentInstance()
        const L = proxy.$getCurLanguage();
        const goodsData = reactive({ data: [], page: {} })
        const indexNum = ref(0)
        const lowprice = ref(null)
        const highprice = ref(null)
        const isEmpty = ref(false)
        const keyword = ref(route.query.keyword != undefined && route.query.keyword ? route.query.keyword : '');//搜索关键词
        const cate1 = reactive({ cate: {}, child: {} })
        const cate2 = reactive({ cate: {}, child: {} })
        const cate3 = reactive({ cate: {} })
        const categoryId3 = ref(route.query.categoryId != undefined && route.query.categoryId ? route.query.categoryId : '')
        const attriList = ref([])
        const attriListTemp = ref([])
        const scrollTop = ref(null)
        const priceDidSel = ref(false)
        // 产品分类数据
		const defaultProps = ref({
			children: 'children',
			label: 'categoryName',
		})
        const colimg = reactive({
            col: require('@/assets/goods/list_col.png'),
            coled: require('@/assets/goods/list_coled.png')
        })
        //方法------------------------------
        const get_show =  (index) => {
            goodsData.data[index].is_show = !goodsData.data[index].is_show 
        }
        //初始化数据，进行请求-start
        const getInitData = (params) => {
            window.scrollTo(0, scrollTop.value)
            let searchParams = { ...params }
            proxy.$get('v3/goods/front/goods/goodsList', searchParams).then(res => {
                firstLoading.value = false;
                priceDidSel.value = false
                if (res.state == 200) {
                    res.data.list.map(i =>{
                        i.is_show=false
                        i.productVOList.map((item)=>{
                            item.buyNum = 1
                        })
                    })
                    goodsData.data = res.data.list
                    isEmpty.value = res.data.list.length ? false : true
                    goodsData.page = res.data.pagination
                    showIndex.value = Number(route.query.g)
                    if (route.query.categoryId && route.query.g && route.query.pid) {
                        let { categoryId, g } = route.query
                        cateForm(categoryId, g)
                    }
                }
            })
        }
        //初始化数据，进行请求-end
        const goGoodList = (data)=>{
            
			// if(data.grade==3||data.grade==2){
                if (data.categoryId) {
                    params.categoryIds = data.categoryId
                }
                getInitData(params)
                router.push('/goods/list?categoryId='+data.categoryId+'&g='+data.grade+'&pid='+data.pid)
			// }
		}
        // 分类列表
		const getCategory = ()=>{
			proxy.$get("v3/goods/front/goods/category/allCategory").then(res => {
				if (res.state == 200) {
					product_list.data = res.data
				}
			}).then(() => {
			
			})
		}
        const cateForm = (c, g) => {
            if (g == 0) {
                return
            }
            if (g == 3) {
                let pid = route.query.pid
                cateForm(pid, 2)
                return
            }
            let param = {
                categoryId: c,
                grade: g
            }
            let cateId = route.query.categoryId
            proxy.$get('v3/goods/front/goods/category/listByPId', param).then(res => {
                if (res.state == 200) {
                    switch (Number(g)) {
                        case 1: {
                            let cdx1 = res.data.findIndex(i => i.categoryId == c)
                            cate1.cate = res.data.filter(i => i.categoryId != c)
                            cate1.child = res.data[cdx1].children
                            catePathName.path[0] = res.data[cdx1].categoryName
                            if (route.query.g == 2) {
                                cate2.cate = cate1.child.filter(i => i.categoryId != cateId)
                            }
                            break;
                        }

                        case 2: {
                            cate2.child = res.data[0].children
                            catePathName.path[1] = res.data[0].categoryName
                            if (route.query.g == 3) {
                                let cdx3 = cate2.child.findIndex(i => i.categoryId == cateId)
                                cate3.cate = cate2.child.filter(i => i.categoryId != cateId)
                                catePathName.path[2] = cate2.child[cdx3].categoryName
                            }
                            let cate2Pid = res.data[0].pid
                            cateForm(cate2Pid, 1)
                            break;
                        }
                    }
                }
            })
        }

        const categorySearch = (data, val) => {//遍历分类列表，找到该categoryId所在的id路径
            for (var i = 0; i < data.length; i++) {
                if (data[i] && data[i].categoryId == val) {
                    return [{
                        categoryId: val,
                        categoryName: data[i].categoryName,
                        children: data[i].children
                    }];
                } if (data[i] && data[i].children) {
                    var d = categorySearch(data[i].children, val);
                    if (d) return d.concat({
                        categoryId: data[i].categoryId,
                        categoryName: data[i].categoryName,
                        children: data[i].children
                    });
                }
            }
        }
        //获取分类Id数组对应的分类名--end

        //去往三级分类
        const goCate3 = (item) => {
            let { categoryId, grade, pid } = item
            router.push({
                path: 'list',
                query: {
                    categoryId,
                    g: grade,
                    pid
                }
            })
        }

        //页数改变的方法-start
        const handlePrevCilickChange = (e) => {
            params.current = e
            getInitData(params)
        }
        const handleNextCilickChange = (e) => {
            params.current = e
            getInitData(params)
        }
        const handleCurrentChange = (e) => {
            params.current = e
            getInitData(params)
        }
        const filterSort = (index) => {

            if (indexNum.value == index) {
                return
            }

            indexNum.value = index
            params.current = 1
            scrollTop.value = document.body.scrollTop || document.documentElement.scrollTop
            router.push({
                path: 'list',
                query: {
                    ...route.query,
                    sort: indexNum.value
                }
            })


        }
        //页数改变的方法-end

        //商品是否自营-start
        const isOwnShop = ref(false)
        const filterStoreSelf = (e) => {
            isOwnShop.value = !e
            params.isSelf = isOwnShop.value ? 1 : 0;
            getInitData(params)
        }
        //商品是否自营-end


        //价格区间事件-start
        const confirm = () => {//价格区间确认按钮

            priceDidSel.value = true


            if (lowprice.value && highprice.value) {

                lowprice.value = Math.abs(lowprice.value)
                highprice.value = Math.abs(highprice.value)

                if (Number(lowprice.value) > Number(highprice.value)) {
                    let temp = lowprice.value
                    lowprice.value = highprice.value
                    highprice.value = temp
                    params.highPrice = highprice.value
                    params.lowPrice = lowprice.value
                    params.current = 1
                    getInitData(params)

                } else {
                    params.highPrice = Number(highprice.value) > 999999 ? 999999 : Number(highprice.value)
                    params.lowPrice = Number(lowprice.value) < 0.01 ? 0.01 : lowprice.value
                    params.current = 1
                    getInitData(params)
                }

            } else if (lowprice.value && !highprice.value) {
                lowprice.value = Math.abs(lowprice.value)
                if (lowprice.value.toString().split(".")[1] && lowprice.value.toString().split(".")[1].length > 2) {
                    lowprice.value = Number(lowprice.value).toFixed(2)
                }
                params.lowPrice = Number(lowprice.value) < 0.01 ? 0.01 : lowprice.value
                delete params.highPrice
            } else if (!lowprice.value && highprice.value) {
                highprice.value = Math.abs(highprice.value)
                if (highprice.value.toString().split(".")[1] && highprice.value.toString().split(".")[1].length > 2) {
                    highprice.value = Number(highprice.value).toFixed(2)
                }
                params.highPrice = Number(highprice.value) > 999999 ? 999999 : Number(highprice.value)
                delete params.lowPrice
            }
        }

        const priceInput = (type, e) => {
            if (type == 'lowprice') {
                lowprice.value = e.target.value
                let low = String(e.target.value).split('.')
                if (low[1] && low[1].length >= 2) lowprice.value = Number(e.target.value).toFixed(2)

            }

            if (type == 'highprice') {
                highprice.value = e.target.value
                let high = String(e.target.value).split('.')
                if (high[1] && high[1].length >= 2) highprice.value = Number(e.target.value).toFixed(2)

            }
        }


        const reset = () => {//价格区间清空按钮
            params.highPrice = highprice.value = null
            params.lowPrice = lowprice.value = null
            params.current = 1
            if (priceDidSel.value) {
                getInitData(params)
            }
            //这是 当 例如 3- 这种情况出现 无法清空，执行
            document.getElementById('lowprice').value = ''
            document.getElementById('highprice').value = ''
        }
        //价格区间事件-end





        //收藏及取消收藏商品
        const collectGoods = (defaultProductId, isFollowGoods) => {
            if (store.state.loginFlag) {  //已登录
                let params = {
                    productIds: defaultProductId,
                    isCollect: !isFollowGoods
                }
                proxy.$post("v3/member/front/followProduct/update", params).then((res) => {
                    if (res.state == 200) {
                        ElMessage.success(res.msg);
                        goodsData.data.map(goodsItem => {
                            if (goodsItem.defaultProductId == defaultProductId) {
                                goodsItem.isFollowGoods = !isFollowGoods;
                            }
                        })

                    } else {
                        ElMessage.error(res.msg);
                    }
                });
            } else {
                //未登录提示登录
                loginModalVisibleFlag.value = true;
            }
        };
        //关闭登录弹框
        const closeLoingModal = () => {
            loginModalVisibleFlag.value = false;
        };

        //属性选择--start
        const attriOption = (attributeName, attributeValue, attributeId, attributeValueId) => {//添加属性查询
            attriList.value.push(attributeValueId)
            attriListTemp.value.push({
                name: attributeName,
                value: attributeValue,
                type: 'attr',
                id: attributeId,
                valueId: attributeValueId
            })
            params.attributeInfo = attriList.value.join(',')
            proxy.$get('v3/goods/front/goods/goodsList', params).then(res => {
                if (res.state == 200) {
                        res.data.list.map(i =>{
                            i.is_show=false
                            i.productVOList.map((item)=>{
                                item.buyNum = 1
                            })
                        })
                    goodsData.data = res.data.list
                    goodsData.page = res.data.pagination
                }

            })


        }
        const attriKick = (index, item) => {//删除属性查询
            attriListTemp.value.splice(index, 1)
            if (item.type == "attr") {
                attriList.value = attriList.value.filter(subitem => subitem != item.valueId)
                proxy.$refs.goodsCate3.attrSorH(item.id)
                if (attriListTemp.value.length) {
                    params.attributeInfo = attriList.value.join(',')
                    proxy.$get('v3/goods/front/goods/goodsList', params).then(res => {
                        if (res.state == 200) {
                                res.data.list.map(i =>{
                                    i.is_show=false
                                    i.productVOList.map((item)=>{
                                        item.buyNum = 1
                                    })
                                })
                            goodsData.data = res.data.list
                            goodsData.page = res.data.pagination
                        }
                    })
                } else {
                    delete params.attributeInfo
                    proxy.$get('v3/goods/front/goods/goodsList', params).then(res => {
                        if (res.state == 200) {
                                res.data.list.map(i =>{
                                    i.is_show=false
                                    i.productVOList.map((item)=>{
                                        item.buyNum = 1
                                    })
                                })
                            goodsData.data = res.data.list
                            goodsData.page = res.data.pagination
                        }
                    })
                }
            } else if (item.type == "brand") {
                delete params.brandIds
                proxy.$refs.goodsCate3.brandSorH()
                proxy.$get('v3/goods/front/goods/goodsList', params).then(res => {
                    if (res.state == 200) {
                            res.data.list.map(i =>{
                                i.is_show=false
                                i.productVOList.map((item)=>{
                                    item.buyNum = 1
                                })
                            })
                        goodsData.data = res.data.list
                        goodsData.page = res.data.pagination
                    }
                })

            }

        }

        const brandOption = (brandId, brandName) => {
            attriListTemp.value.push({
                name: '品牌',
                value: brandName,
                type: 'brand',
            })
            params.brandIds = brandId
            proxy.$get('v3/goods/front/goods/goodsList', params).then(res => {
                    res.data.list.map(i =>{
                        i.is_show=false
                        i.productVOList.map((item)=>{
                            item.buyNum = 1
                        })
                    })
                goodsData.data = res.data.list
                goodsData.page = res.data.pagination
            })

        }
        //属性选择--end
        /**编辑购物车商品数量
       * type:编辑类型 reduce：减  edit：编辑 add：加
       * curCartItem：编辑的当前项商品
       * e:事件对象
       */
      const editNum = (type, curCartItem, e) => {
         // 判断是否登录 未登录显示登录弹框
         if (!store.state.loginFlag) {
            loginModalVisibleFlag.value = true;
            return
         }
         let curNumber = curCartItem.buyNum;

         let maxMin = Math.min(curCartItem.productStock, 99999)
         switch (type) {
            case 'reduce': {
               if (curNumber > 1) {
                  curCartItem.buyNum--;
                  curNumber--
               } else {
                  curCartItem.buyNum = 1;
                  ElMessage.error(L["最低限购1件!"]);
               }
               break
            }

            case 'add': {
               curCartItem.buyNum++
               if (curCartItem.buyNum > maxMin) {
                  ElMessage.error(L["数量超出购买范围！"]);
                  curCartItem.buyNum = maxMin
               }
               break;
            }


            case 'edit': {
               curNumber = e.currentTarget.value;
               if (curCartItem.buyNum == 0 && curCartItem.buyNum != '') {
                  curCartItem.buyNum = 1;
                  curNumber = 1
                  return
               } else if (curCartItem.buyNum == '') {
                  return
               } else {
                  curCartItem.buyNum = curCartItem.buyNum.replace(/\D/g, "");
                  if (curCartItem.buyNum > maxMin) {
                     curCartItem.buyNum = maxMin
                     return
                  }
               }
               break
            }
            case 'blur': {
               if (curNumber == '') {
                  curCartItem.buyNum = 1
                  return
               }
            }
         }
         curNumber = curCartItem.buyNum
         

      };
      //加入购物车
		const addCart = (item) => {
			if (store.state.loginFlag) {
				let paramsData = {
					productId: item.productId,
					number: item.buyNum,
				};
				proxy.$addCart(paramsData);
			} else {
				// 如果未登录 则不允许加入购物车 跳转登录页
				loginModalVisibleFlag.value = true;
				return
			}
		};
        //监听事件--start
        watchEffect(() => {
            if (route.query.keyword != undefined) {
                keyword.value = route.query.keyword;
                categoryId3.value = ""
                showIndex.value = -1
                catePathName.path = []
                params.keyword = keyword.value
                delete params.categoryIds
                getInitData(params)

            } else if (route.query.categoryId != undefined) {
                categoryId3.value = route.query.categoryId;
                keyword.value = "";
                params.categoryIds = route.query.categoryId
                delete params.keyword
                getInitData(params)
            }
        });
        watch(() => route.query.categoryId, (nv, ov) => {
            if (nv != ov) {
                categoryId3.value = nv
                attriList.value = []
                attriListTemp.value = []
                lowprice.value = highprice.value = null
                isOwnShop.value = false
            }

        })
        watch(() => route.query.keyword, (nv, ov) => {
            if (nv != ov) {
                lowprice.value = highprice.value = null
                isOwnShop.value = false
                delete params.highPrice
                delete params.lowPrice
            }
        })

        watch(() => route.query.sort, (nv, ov) => {

            params.sort = route.query.sort
            indexNum.value = route.query.sort ? route.query.sort : 0

        })

        //监听事件--end


        router.beforeEach((to, from) => {
            if (to.path == from.path) {
                document.body.scrollTop = scrollTop.value
            }
        })


        onMounted(() => {
            if (route.query.categoryId) {
                params.categoryIds = route.query.categoryId
            }
            if (route.query.keyword) {
                params.keyword = route.query.keyword
            }
            if (route.query.storeId) {
                params.storeId = route.query.storeId

            }
            if (route.query.goodsIds) {
                params.goodsIds = route.query.goodsIds
            }
            if (route.query.brandId) {
                params.brandIds = route.query.brandId
            }

            if (route.query.sort) {
                params.sort = route.query.sort
                indexNum.value = route.query.sort
            }
            getInitData(params)
            getCategory()
        })

        //返回值
        return {
            addCart,
            editNum,
            getCategory,
            product_list,
            goodsData,
            handlePrevCilickChange,
            handleNextCilickChange,
            handleCurrentChange,
            L,
            catePathName,
            catePath,
            showIndex,
            indexNum,
            filterSort,
            filterStoreSelf,
            isOwnShop,
            lowprice,
            highprice,
            confirm,
            reset,
            isEmpty,
            keyword,
            cate1,
            cate2,
            cate3,
            firstLoading,
            skeletonData,
            collectGoods,
            loginModalVisibleFlag,
            closeLoingModal,
            goCate3,
            categoryId3,
            attriOption,
            attriList,
            attriKick,
            attriListTemp,
            brandOption,
            priceInput,
            colimg,
            defaultProps,
            get_show,
            goGoodList,
        }
    }
}


</script>

<style lang="scss" scoped>
@import '../../style/goodsList.scss';
@import '../../style/base.scss';

input[type="checkbox"] {
    display: none;
    vertical-align: middle;
    margin-bottom: 3px;
    margin-right: 3px;
}

input[type="checkbox"]+label {
    background: url('../../assets/goods/unsel.png') left center no-repeat;
    padding-left: 20px;
    background-size: 12px 12px;
}

input[type="checkbox"]:checked+label {
    background-image: url('../../assets/goods/select.png');
}

.empty_page {
    flex-direction: column;
    padding: 100px;
}

.sld_pagination {
    margin-top: 30px;
    margin-bottom: 30px;
}

/*添加css样式*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type="number"] {
    -moz-appearance: textfield;
}

</style>
<style lang="scss">
 .goods_list_container{
    .el-tree-node__content{
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 15px;
        color: #333333;
        height: 50px;
        background: #fff;
        .el-tree-node__label{
            font-size: 17px;
            
        }
        
    }
    .el-tree-node__children {
        font-family: Microsoft YaHei;
        font-weight: bold;
        font-size: 15px;
        color: #333333;
        .el-tree-node__content{
            height: 50px;
            background: #FAFBFC;
            
        }
    }
}
</style>